/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import {RiCalendarTodoFill, RiCamera3Line, RiLock2Line} from 'react-icons/ri'
import {MdLogout, MdOutlineComment} from 'react-icons/md'
import UserContext from "../Context/UserContext"
import './Styles/HomePage.css'
import Spinner from "../Components/Spinner"
import { signOut } from "../Requests/firebaseAuth"
import { useTranslation } from "react-i18next"

export default function HomePage(){
  const navigate = useNavigate()
  const {t} = useTranslation()
  const {user} = useContext(UserContext)
  const [loading, setLoading] = useState(true)

  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  useEffect(()=>{
    if(user!=='checking'){
      setLoading(false)
    }
  },[user])
  const handleSignIn = () => {
    navigate('/signin')
  }

// eslint-disable-next-line
    return(
    <div className="container mx-auto">
            <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
      <img alt="Channel Talks logo" src={require('../Assets/channeltalks-white.png')}/>
      <img alt="Channel Talks logo" src={require('../Assets/slogan-white.png')}/>
      </div>
      {loading?
      <div className="text-white py-5">
        <Spinner/>
      </div>
      :
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10 items-center font-semibold">
        <div className="flex flex-col relative mb-[20px] sm:mb-0">

        {user!==false &&   user!=='checking'?<>
          <button className="button flex flex-col" onClick={handleSignIn}><RiLock2Line size={40}/>
          <span>{t('accessAs')}</span>
          <span>{user.fullName}</span>
          </button>
        <button onClick={signOut} className="text-white text-sm flex items-center gap-2 absolute -bottom-[30px] w-full justify-center">{t('signOut')}<MdLogout size={25}/></button>
        </>:<>
          <button className="button" onClick={handleSignIn}><RiLock2Line size={40}/>{t('signIn')}</button>
        </>}
        </div>
        <div className="bg-white rounded-[10px] h-1 w-48 sm:w-1 sm:h-48"></div>
        <a className="button light" href="https://mediaware.org/channeltalks"><RiCalendarTodoFill size={40}/><span>{t('events')}</span></a>
        <a className="button light" href="https://mediaware.org/channeltalks/agenda"><MdOutlineComment size={40}/><span>{t('talks')}</span></a>
        <a className="button light" href=""><RiCamera3Line size={40}/><span>{t('gallery')}</span></a>

      </div>
      }
    </div>
    )
  }